import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/site";

export default function Faq() {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" data-testid="faq-section" className="py-16 md:py-24 lg:py-32 bg-[#FDF0F4]">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">Questions</p>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#3D2318]">
                        Sweet Answers
                    </h2>
                </Reveal>

                <div className="mt-12 space-y-4" data-testid="faq-list">
                    {FAQS.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={i} delay={i * 0.06}>
                                <div
                                    className={`rounded-2xl border transition-[background-color,border-color,box-shadow] duration-300 ${
                                        isOpen
                                            ? "bg-white border-[#D4AF37]/40 shadow-[0_12px_32px_rgba(61,35,24,0.08)]"
                                            : "bg-white/70 border-[#F2E1E6]"
                                    }`}
                                    data-testid={`faq-item-${i}`}
                                >
                                    <button
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        data-testid={`faq-toggle-${i}`}
                                        className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                                    >
                                        <span className="font-display text-base sm:text-lg font-semibold text-[#3D2318]">{f.q}</span>
                                        <motion.span
                                            animate={{ rotate: isOpen ? 45 : 0 }}
                                            transition={{ duration: 0.3 }}
                                            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isOpen ? "bg-[#C95B7D] text-white" : "bg-[#FDF0F4] text-[#C95B7D]"}`}
                                        >
                                            <Plus className="h-4 w-4" />
                                        </motion.span>
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                                className="overflow-hidden"
                                            >
                                                <p className="px-6 pb-6 text-sm sm:text-base text-[#6B4A3E] leading-relaxed" data-testid={`faq-answer-${i}`}>
                                                    {f.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
